import { render, staticRenderFns } from "./check-list-item.vue?vue&type=template&id=d5143c64&"
import script from "./check-list-item.vue?vue&type=script&lang=js&"
export * from "./check-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports